<template>
  <el-dialog
    title="配置类型"
    :visible="visible"
    width="820px"
    :destroy-on-close="true"
    :lock-scroll="false"
    @update:visible="updateVisible">
    <ele-pro-table
      ref="table"
      :datasource="url"
      :columns="columns"
      :toolkit="[]"
      height="420px"
      tool-class="ele-toolbar-form">
      <template slot="toolbar">
        <el-button size="small" type="primary" icon="el-icon-plus" class="ele-btn-icon" @click="openEdit(null)">添加</el-button>
      </template>
      <template slot="listClass" slot-scope="{ row }">
        <el-tag v-bind="tagBind(row.list_class)" size="mini">{{ row.name }}</el-tag>
      </template>
      <template slot="status" slot-scope="{ row }">
        <el-switch
          v-model="row.status"
          :active-value="1"
          :inactive-value="2"
          @change="editStatus(row)" />
      </template>
      <template slot="action" slot-scope="{ row }">
        <el-button size="mini" type="primary" class="ele-btn-icon" @click="openEdit(row)">编辑</el-button>
        <el-popconfirm class="ele-action" title="确定删除该类型？" @confirm="remove(row)">
          <el-button size="mini" type="danger" class="ele-btn-icon" slot="reference">删除</el-button>
        </el-popconfirm>
      </template>
    </ele-pro-table>

    <el-dialog
      :title="isUpdate ? '编辑类型' : '添加类型'"
      :visible.sync="showEdit"
      width="460px"
      append-to-body
      :destroy-on-close="true">
      <el-form ref="form" :model="form" :rules="rules" label-width="90px">
        <el-form-item label="类型名称" prop="name">
          <el-input v-model.trim="form.name" maxlength="50" clearable placeholder="请输入" />
        </el-form-item>
        <el-form-item label="类型编码" prop="code">
          <el-input v-model.trim="form.code" maxlength="50" clearable placeholder="请输入" />
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="form.sort" :min="0" :max="9999" controls-position="right" class="ele-fluid ele-text-left" />
        </el-form-item>
        <el-form-item label="样式">
          <el-select v-model="form.list_class" clearable placeholder="请选择" class="ele-block">
            <el-option
              v-for="item in styleOptions"
              :key="'style-' + (item.value || 'default')"
              :label="item.label"
              :value="item.value">
              <el-tag :type="item.value || 'info'" size="mini">{{ item.label }}</el-tag>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="form.name" label="效果预览">
          <el-tag :type="previewTag.type || undefined" :style="previewTag.style" size="small">{{ form.name }}</el-tag>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.status">
            <el-radio v-for="item in statusOptions" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit = false">取消</el-button>
        <el-button type="primary" :loading="loading" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { DICT_TAG_TYPES, clearDictCache, loadDictOptions, resolveDictTag } from '@/utils/dict';

const defaultForm = () => ({
  id: 0,
  name: '',
  code: '',
  list_class: '',
  sort: 0,
  status: 1
});

export default {
  name: 'TypeNameConfig',
  props: {
    visible: Boolean
  },
  data() {
    return {
      url: '/channeltypename/index',
      columns: [
        { prop: 'name', label: '类型名称', align: 'center', minWidth: 120, showOverflowTooltip: true },
        { prop: 'code', label: '类型编码', align: 'center', minWidth: 100, showOverflowTooltip: true },
        { prop: 'list_class', label: '样式', align: 'center', width: 120, slot: 'listClass' },
        { prop: 'sort', label: '排序', align: 'center', width: 80 },
        { prop: 'status', label: '状态', align: 'center', width: 90, slot: 'status' },
        {
          columnKey: 'action',
          label: '操作',
          width: 160,
          align: 'center',
          resizable: false,
          slot: 'action',
          fixed: 'right'
        }
      ],
      showEdit: false,
      isUpdate: false,
      loading: false,
      form: defaultForm(),
      styleOptions: DICT_TAG_TYPES,
      statusOptions: [],
      rules: {
        name: [{ required: true, message: '请输入', trigger: 'blur' }],
        code: [{ required: true, message: '请输入', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入', trigger: 'change' }]
      }
    };
  },
  computed: {
    previewTag() {
      return resolveDictTag(this.form.list_class);
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.$nextTick(() => this.reload());
      }
    }
  },
  mounted() {
    loadDictOptions('switch_status', { numberValue: true })
      .then((list) => { this.statusOptions = list; })
      .catch((e) => { this.$message.error(e.message); });
  },
  methods: {
    updateVisible(val) {
      this.$emit('update:visible', val);
    },
    tagBind(listClass) {
      const tag = resolveDictTag(listClass);
      return {
        type: tag.type || undefined,
        style: tag.style
      };
    },
    notifyDictChanged() {
      clearDictCache('type_name');
    },
    reload() {
      if (this.$refs.table) {
        this.$refs.table.reload();
      }
    },
    openEdit(row) {
      if (row) {
        this.isUpdate = true;
        this.form = {
          id: row.id,
          name: row.name,
          code: row.code,
          list_class: row.list_class,
          sort: Number(row.sort) || 0,
          status: Number(row.status) || 1
        };
      } else {
        this.isUpdate = false;
        this.form = defaultForm();
      }
      this.showEdit = true;
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        this.$http.post('/channeltypename/edit', this.form).then((res) => {
          this.loading = false;
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.showEdit = false;
            this.notifyDictChanged();
            this.reload();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch((e) => {
          this.loading = false;
          this.$message.error(e.message);
        });
      });
    },
    remove(row) {
      const loading = this.$loading({ lock: true });
      this.$http.post('/channeltypename/delete', { id: row.id }).then((res) => {
        loading.close();
        if (res.data.code === 0) {
          this.$message.success(res.data.msg);
          this.notifyDictChanged();
          this.reload();
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        loading.close();
        this.$message.error(e.message);
      });
    },
    editStatus(row) {
      const loading = this.$loading({ lock: true });
      const prev = row.status === 1 ? 2 : 1;
      this.$http.post('/channeltypename/status', {
        id: row.id,
        status: row.status
      }).then((res) => {
        loading.close();
        if (res.data.code === 0) {
          this.$message.success(res.data.msg);
          this.notifyDictChanged();
        } else {
          row.status = prev;
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        loading.close();
        row.status = prev;
        this.$message.error(e.message);
      });
    }
  }
};
</script>
